module.exports = __webpack_public_path__ + "img/tripdaze-screens.c251bce8.png";